export default __webpack_public_path__ + "static/media/green.a70095ce.png";